import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage from "./pages/HomePage";
import StartWizard from "./pages/StartWizard";
import PersonPage from "./pages/PersonPage";
import AdminPage from "./pages/AdminPage";
import NotFound from "./pages/NotFound";
import { Toaster } from "./components/ui/toaster";

// Custom domains that land directly on a person's page
const getDomainSlug = () => {
  const host = window.location.hostname.toLowerCase();
  if (host === "praymoore.family" || host.endsWith(".praymoore.family")) {
    return "darius-moore";
  }
  return null;
};

function App() {
  const domainSlug = getDomainSlug();

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={domainSlug ? <PersonPage forcedSlug={domainSlug} /> : <HomePage />} />
          <Route path="/home" element={<HomePage />} />
          <Route path="/start" element={<StartWizard />} />
          <Route path="/404" element={<NotFound />} />
          {domainSlug && <Route path="/admin" element={<AdminPage forcedSlug={domainSlug} />} />}
          <Route path="/:slug/admin" element={<AdminPage />} />
          <Route path="/:slug" element={<PersonPage />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
